export default __webpack_public_path__ + "static/media/video_disconnect.f4ad0132.wav";